import { Button, CloseButton, Dialog, HStack, Portal, Text } from "@chakra-ui/react";
import { Field, FormTextarea } from "@/components/jobOffer/ui";

const AddLeadNoteModal = ({ isOpen, onClose, noteContent, setNoteContent, onSubmit, isLoading }) => (
    <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
        <Portal>
            <Dialog.Backdrop />
            <Dialog.Positioner p={4}>
                <Dialog.Content
                    bg="white" color="gray.900" borderColor="gray.200" border="1px solid"
                    boxShadow="0 4px 24px rgba(23,21,31,0.12)"
                    w={{ base: "calc(100vw - 2rem)", md: "lg" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                    overflowY="auto" borderRadius={12}
                >
                    <Dialog.Body pt={6} pb={6} px={6}>
                        <Text fontWeight={700} fontSize="lg" color="gray.900" mb={4}>Dodaj notatkę</Text>
                        <Field label="Treść notatki">
                            <FormTextarea
                                placeholder="Treść notatki..."
                                value={noteContent}
                                onChange={(e) => setNoteContent(e.target.value)}
                                rows={5}
                                resize="vertical"
                            />
                        </Field>
                        <HStack justify="flex-end" gap={2} mt={4}>
                            <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                            <Button variant="primary" size="sm" loading={isLoading} disabled={!noteContent.trim()} onClick={onSubmit}>
                                Dodaj
                            </Button>
                        </HStack>
                    </Dialog.Body>
                    <Dialog.CloseTrigger asChild>
                        <CloseButton size="sm" position="absolute" top="2" right="2" color="gray.400" _hover={{ color: "gray.600", bg: "gray.100" }} />
                    </Dialog.CloseTrigger>
                </Dialog.Content>
            </Dialog.Positioner>
        </Portal>
    </Dialog.Root>
);

export default AddLeadNoteModal;
